<header class="app-header">
  <div class="header-container">
    <div class="logo-wrapper">
      <img src="assets/icons/logo.svg" alt="Vivest" class="logo" />
    </div>
  </div>
</header>
